export const formatDateHourView = (dateString: Date | string): string => {
  const date: Date = new Date(dateString);

  // Pad single digits with leading zero
  // @ts-ignore
  const pad = (num) => (num < 10 ? `0${num}` : num);

  const formattedDate: string = `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`;

  return formattedDate;
};

export const formatDateView = (dateString: Date | string | null | undefined): string => {
  if (!dateString) return ""; 

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  const pad = (num: number) => (num < 10 ? `0${num}` : num);
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
};


export const formatTypePurchase = (value: number): string => {
  let typePurchase: string = '';

  switch (value) {
    case 1: typePurchase = 'Débito';
      break;
    case 2: typePurchase = 'Crédito'
  }

  return typePurchase;
}

export const formatMoneyView = (value: number | null): string => {
  if (value === null || value === undefined || typeof value !== 'number') {
    return '';
  }

  const formattedValue: string = (value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formattedValue;
};

export function formatBrandView(bandeira: string): string {
  let bandeiraFormatada = '';

  switch (bandeira) {
    case "MASTERCARD":
    case "MAESTRO":
    case "MASTERCARD DEBITO":
    case "MAESTROCP":
      bandeiraFormatada = 'MASTERCARD';
      break;
    case "VISA ELECTRON":
    case "VISA":
    case "VISA ELECTRON NACIO":
      bandeiraFormatada = 'VISA';
      break;
    case "ELO DEBITO":
    case "ELO CREDITO":
    case "ELO VISA DEBITO":
    case "ELO VISA CREDITO":
      bandeiraFormatada = 'ELO';
      break;
    case "AMEX CREDITO":
    case "AMEX":
    case "AMERICAN EXPRESS":
      bandeiraFormatada = 'AMEX';
      break;
    case "HIPERCARD CRD":
    case "HIPERCARD":
      bandeiraFormatada = 'HIPERCARD';
      break;
    default:
      bandeiraFormatada = bandeira;
      break;
  }
  return bandeiraFormatada;
}

export function formatBrandCodeView(bandeira: string): string {
  let bandeiraFormatada = '';

  switch (bandeira) {
    case "006":
      bandeiraFormatada = 'AMEX';
      break;
    case "008":
      bandeiraFormatada = 'ELO';
      break;
    case "027":
      bandeiraFormatada = 'ELO DÉBITO';
      break;
    case "003":
      bandeiraFormatada = 'MASTERCARD';
      break;
    case "025":
      bandeiraFormatada = 'MASTERCARD DÉBITO';
      break;
    case "021":
      bandeiraFormatada = 'HIPERCARD';
      break;
    case "004":
      bandeiraFormatada = 'VISA';
      break;
    case "026":
      bandeiraFormatada = 'VISA DÉBITO';
      break;
    default:
      bandeiraFormatada = bandeira;
      break;
  }

  return bandeiraFormatada;
}

export const formatEffectTypeView = (effectType: string): string => {
  let formattedEffectType: string = "";
  if (effectType === null || effectType === undefined) {
    return formattedEffectType;
  } else if (effectType === "1") {
    formattedEffectType = "Troca de Titularidade";
  } else if (effectType === "2") {
    formattedEffectType = "Ônus - Cessão fiduciária";
  } else if (effectType === "3") {
    formattedEffectType = "Ônus - Outros";
  } else if (effectType === "4") {
    formattedEffectType = "Bloqueio judicial";
  } else if (effectType === "8") {
    formattedEffectType = "Promessa de Cessão";
  }

  return formattedEffectType;
};

export const formatDivisionRuleView = (divisionRule: string): string => {
  let formattedDivisionRule: string = "";
  if (divisionRule === null || divisionRule === undefined) {
    return formattedDivisionRule;
  } else if (divisionRule === "1") {
    formattedDivisionRule = "Fixo";
  } else if (divisionRule === "2") {
    formattedDivisionRule = "Percentual";
  }

  return formattedDivisionRule;
};

export const formatEffectContractStatusView = (status: string): string => {
  let formattedstatus: string = "";
  if (status === null || status === undefined) {
    return formattedstatus;
  } else if (status === "P") {
    formattedstatus = "Pendente";
  } else if (status === "C") {
    formattedstatus = "Ativo";
  } else if (status === "A") {
    formattedstatus = "Ativo";
  } else if (status === "B") {
    formattedstatus = "Baixado";
  }

  return formattedstatus;
};

export const formatReceiverTypeCodeView = (status?: number): string => {
  if (status === null || status === undefined) return "";

  switch (status) {
    case 1:
      return "Credor";
    case 2:
      return "Merchant";
    case 4:
      return "Split";
    default:
      return "";
  }
};



export const formatPaymentRecipientType = (value: string): string => {
  let formattedPaymentRecipientTye: string = "";
  if (value === null || value === undefined) {
    return formattedPaymentRecipientTye;
  } else if (value === "C") {
    formattedPaymentRecipientTye = "Credor";
  } else if (value === "M") {
    formattedPaymentRecipientTye = "Cliente";
  }

  return formattedPaymentRecipientTye;
};

export const formatCommitValue = (
  value?: number | null,
  divisionRule?: string | number | null
): string => {
  let formattedPaymentRecipientTye: string = "-";
  if (value === null || value === undefined || divisionRule === null || divisionRule === undefined) {
    return formattedPaymentRecipientTye;
  }else if (divisionRule == "1") {
    formattedPaymentRecipientTye = formatMoneyView(value);
  }else if (divisionRule == "2"){
    formattedPaymentRecipientTye = `${value}%`
  }
  return formattedPaymentRecipientTye;
};

export const formatMoneyCentsView = (value: number | null): string => {
  if (value === null || value === undefined || typeof value !== 'number') {
    return '';
  }

  value = value / 100

  const formattedValue: string = (value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formattedValue;
};

export const formatDocument = (document: string): string => {
  const cleaned = document.replace(/\D/g, ''); // Remove tudo que não for número

  if (cleaned.length === 11) {
    // Formatar CPF (###.###.###-##)
    return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } else if (cleaned.length === 14) {
    // Formatar CNPJ (##.###.###/####-##)
    return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  } else {
    // Retorna o original se não for nem CPF nem CNPJ
    return document;
  }
};


  export const formatPercentageView = (value : any) => {
    if (!value) return '';

    const padded = value.padStart(5, '0');
    const intPart = padded.slice(0, -4) || '0';
    const decPart = padded.slice(-4);
    const intTrimmed = String(parseInt(intPart, 10) || 0);
  
    return `${intTrimmed}.${decPart}`;
  };

  export const formatCurrency = (value: any) => {
  if (!value && value !== 0) return '';

  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return formatter.format(value / 100);
};